export default __webpack_public_path__ + "static/media/case_details_03.15157061.jpg";